import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import { ImageUrl } from '../../../../../../Helpers/request';
import DiamondRing from '../../../../../../Assets/images/diamond-ring-img.webp'
import startRing from '../../../../../../Assets/images/start-ring.png'
import startDiamond from '../../../../../../Assets/images/start-diamond.png'
import { Container, Image } from 'react-bootstrap';

const CreateOwnDiamond = ({container}) => {

    return (
        <>
            <section className='create_own_diamond_ring'>
                <Container className={`${container ? "" : 'container-whitebox'}`}>
                    <div className='row  d-flex align-items-center'>
                          <div className=' col-xs-12 col-xl-6 col-lg-6 col-md-12 text-center'>
                            <Image className='img-fluid  mb-4 mb-4 mb-md-0 w-100 h-auto' src={DiamondRing} alt=""  />
                        </div>
                        <div className='col-xs-12 col-xl-6 col-lg-6 col-md-12 align-self-center'>
                            <div className='right-content text-center'>
                                   <div className='title-box text-center mb-4'>
                                       <h6 className='text-capitalize'>Design your Own</h6>
                        <h2>Diamond Ring</h2>
                        <p>Design a Diamond Ring That Reflects Your Style and Personality</p>
                    </div>
                                {/* <p>Design Yur Own</p>
                                <h2>Diamond Ring</h2>
                                <p>Design a Diamond Ring That Reflects Your Style and Personality</p> */}

                                <div className='btn-groups d-block d-md-flex justify-content-start'>
                                    <div className='start_with_box_inner'>
                                    <Image src={startRing} alt=''  className='img-fluid'/>
                                    <h3>Start with setting</h3>
                                    <p>Select a setting that matches your style and highlights your stone.</p>
                                    <Link to="/ringsettings" className='btn-section'>Select Setting </Link>
                                    </div>
                                     <div className='start_with_box_inner'>
                                    <Image src={startDiamond} alt=''  className='img-fluid'/>
                                    <h3>Start with Diamond</h3>
                                    <p>Your diamond, your brilliance—choose the stone that shines for you.</p>
                                    <Link to="/diamonds" className='btn-section'>Select Diamond  </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>

    )
}

export default CreateOwnDiamond;